export default __webpack_public_path__ + "static/media/custody-exchange.a758775d.svg";